import { Component } from '@angular/core';

/**
 * Generated class for the FriendsIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'friends-icon',
  templateUrl: 'friends-icon.html'
})
export class FriendsIconComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/icons/friends-icon/friends-icon.ts